import { formatted_date_for_backend } from "../../helper/Generic/dateTimeFormat";
import { POST } from "../APiHelper/API";


export const sendRsSelection = (bet_id, price, stake, active_until, onSuccess, onError) => {

    const data = {
        bet_id: bet_id,
        price: price,
        stake: stake,
        active_until: formatted_date_for_backend(active_until),
    }
    POST("/api/v1/runshop_bets/send_selection", data, onSuccess, onError);
}